// Copyright (C) 2025 Skylark Drones

import BaseApi from './baseHttpApi'
import { BASE_API_HOST_URL } from '@/constants'

export default class internalApi extends BaseApi {
  whitelistURLs = []

  constructor() {
    super('api/internal', BASE_API_HOST_URL)
  }
}
